/* eslint-disable react/prop-types */
// LanguageContext.js
import { createContext, useContext, useState, useEffect } from "react";
import i18next from "i18next";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const storedLang = localStorage.getItem("lang");
    try {
      return storedLang ? JSON.parse(storedLang) : "ar";
    } catch (error) {
      return "ar";
    }
  });

  useEffect(() => {
    localStorage.setItem("lang", JSON.stringify(lang));
    i18next.changeLanguage(lang);
    document.body.dir = i18next.dir(lang);
    // document.documentElement.style.setProperty(
    //   "--main-font",
    //   lang === "en" ? "'Inter', serif" : "'Cairo', sans-serif"
    // );
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
